import Nav from "@/components/site/Nav";
import LightningBanner from "@/components/site/LightningBanner";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import Services from "@/components/site/Services";
import ProcessingCapital from "@/components/site/ProcessingCapital";
import LightningFunding from "@/components/site/LightningFunding";
import McaConsolidation from "@/components/site/McaConsolidation";
import HowWeWork from "@/components/site/HowWeWork";
import About from "@/components/site/About";
import CreditRepair from "@/components/site/CreditRepair";
import Heloc from "@/components/site/Heloc";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { useState } from "react";
import ApplicationDialog from "@/components/site/ApplicationDialog";

export default function Landing() {
  const [openApply, setOpenApply] = useState(false);
  const [prefill, setPrefill] = useState({});

  const handleApply = (data = {}) => {
    setPrefill(data);
    setOpenApply(true);
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <LightningBanner
        onGetFunded={() =>
          handleApply({
            funding_purpose: "Lightning Funding (Emergency)",
            funding_amount: 50000,
          })
        }
      />
      <Nav onGetFunded={() => handleApply()} />
      <Hero onApply={handleApply} />
      <TrustBar />
      <Services onApply={handleApply} />
      <ProcessingCapital onApply={handleApply} />
      <LightningFunding onApply={handleApply} />
      <McaConsolidation onApply={handleApply} />
      <HowWeWork />
      <About />
      <CreditRepair onApply={handleApply} />
      <Heloc onApply={handleApply} />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <ApplicationDialog open={openApply} onClose={() => setOpenApply(false)} prefill={prefill} />
    </div>
  );
}
